import clsx from 'clsx';
import type { IconProps } from '../components/types.js';
import { fgTone } from '../utils/style/tone.js';
const displayName = 'IconDeliveryPlane';
/** Renders an SVG icon. */
const SvgDeliveryPlane = ({
  size,
  'aria-hidden': ariaHidden,
  tone,
  UNSAFE_className,
  UNSAFE_style,
  ...rest
}: IconProps) => {
  const props = {
    ...rest,
    'aria-hidden': ariaHidden ?? (rest['aria-label'] == null && rest['aria-labelledby'] == null),
    className: clsx('cim-icon', tone && fgTone(tone), UNSAFE_className),
    style: UNSAFE_style,
    width: size != null ? size + 'px' : '1em',
    height: size != null ? size + 'px' : '1em',
  };
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" data-icon="true" fill="currentColor" {...props}>
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M14.862 15.6a1 1 0 0 1 .638-.525l.903-.242a4 4 0 0 1 4.439 1.762l1.179 1.91 2.81-.753a4 4 0 0 1 3.618.809l1.06.897c1.233 1.043.786 3.04-.773 3.459l-5.212 1.396-.145 1.493a4 4 0 0 1-2.946 3.476l-1.05.282a1 1 0 0 1-1.255-.87l-.277-2.86-3.514.94a2 2 0 0 1-2.28-.986l-2.502-4.669a1 1 0 0 1 .623-1.438l1.974-.529a3 3 0 0 1 2.544.474l.843.615.796-.213-1.5-3.603a1 1 0 0 1 .027-.825m3.422 3.906 1.72-.461-.864-1.399a2 2 0 0 0-2.015-.925zm-6.37 1.78 1.905 3.557 4.655-1.247a1 1 0 0 1 1.254.87l.277 2.858a2 2 0 0 0 1.384-1.712l.212-2.182a1 1 0 0 1 .736-.87l5.88-1.575-1.06-.897a2 2 0 0 0-1.809-.405l-9.753 2.614a1 1 0 0 1-.848-.158l-1.23-.897a1 1 0 0 0-.848-.158l-.755.203Z"
      />
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M7.2 4.4A1 1 0 0 1 8 4h10a1 1 0 0 1 .8.4l3 4a1 1 0 0 1 .2.6v5a1 1 0 1 1-2 0v-4H6v9h1a1 1 0 1 1 0 2H6a2 2 0 0 1-2-2V9a1 1 0 0 1 .2-.6zM7 8h5V6H8.5zm7-2v2h5l-1.5-2zm-6 7a1 1 0 0 1 1-1h3a1 1 0 1 1 0 2H9a1 1 0 0 1-1-1m0 3a1 1 0 0 1 1-1h1a1 1 0 1 1 0 2H9a1 1 0 0 1-1-1"
      />
    </svg>
  );
};
SvgDeliveryPlane.displayName = displayName;
export default SvgDeliveryPlane;
